import { Action } from "../actions/actionsShared";
import { FETCH_USER_WIDGETS_PREFIX } from "../actions/dashboardActions";


const initialState = {
  widgets: [],
  loadingWidgets: false
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_USER_WIDGETS_PREFIX}${Action.BEGIN_SUFFIX}`:
      return {
        ...state,
        loadingWidgets: true,
        result: 'BEGINNING',
      };
    case `${FETCH_USER_WIDGETS_PREFIX}${Action.SUCCESS_SUFFIX}`:
      const widgets = action.payload.data.data.message;
      widgets.forEach((widget) => widget.id = crypto.randomUUID())
      return {
        ...state,
        widgets,
        loadingWidgets: false,
        result: 'SUCCESS',
      };
    case `${FETCH_USER_WIDGETS_PREFIX}${Action.FAILURE_SUFFIX}`:
      return {
        ...state,
        loadingWidgets: false,
        result: 'FAILURE'
      }
    default:
      return state;
  }
};

export default dashboardReducer;
